import { useMutation, useQueryClient } from 'react-query'
import { useSelector } from 'react-redux'

import { makeSelectContentTypesByModel } from '@webapp/core/stores/global'
import { permissionRepository } from '@webapp/platform/iam/data-access/repositories/PermissionRepository'
import { reportAccessGrantQueryConfig } from '@webapp/platform/iam/query-configs/reportAccessGrant'

export const useMutateClearSecondaryCategoryReportAccess = () => {
  const queryClient = useQueryClient()
  const secondaryCategoryContentType = useSelector(
    makeSelectContentTypesByModel('procurify', 'department')
  )

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ({ secondaryCategoryId }: { secondaryCategoryId: number }) =>
      permissionRepository.clearSecondaryCategoryReportAccess({
        secondaryCategoryContentTypeId: secondaryCategoryContentType.id,
        secondaryCategoryId,
      }),
    onSuccess: (_, { secondaryCategoryId }) => {
      // Partial key — prefix-matches every grants list for this
      // SecondaryCategory regardless of content-type id (ADR-5)
      queryClient.invalidateQueries(
        reportAccessGrantQueryConfig.list({ secondaryCategoryId }).queryKey
      )
    },
  })

  return {
    clearSecondaryCategoryReportAccess: mutateAsync,
    isClearing: isLoading,
  }
}
